<template>
  <div class="content">
    <div class="content-top">
      {{ name.toUpperCase() }}
    </div>
    <div class="content-center">
      <div class="content-left">
        <div class="image-container">
          <div
            class="cloudimage-360"
            id="gurkha-suv"
            :data-folder="'/assets/360_degree/'+name+'/'"
            data-filename-x="{index}.jpg"
            :data-amount-x="showed_image_amount"
            data-transformation="w=444&h=429&func=fit"
          ></div>
        </div>
      </div>
      <div class="content-right">
        <p class="question-one">NO CUSTOMIZATION NEEDED</p>
        <p class="question-two">This product is ready as is. You can proceed to the next step.</p>
        <button class="actionButton" @click="next">Next</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "NoCustomizationNeeded",
    props: {
      name: {
        type: String,
        required: true
      },
      showed_image_amount: {
        type: Number,
        required: true
      }
    },
    mounted(){
      window.CI360.init();
    },
    methods:{
      next() {
        this.$emit('next', "nextProduct");
      }
    }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.content{
  position: relative;
  overflow: hidden;
}
.content-top{
  position: absolute;
  left: 51.1667vw;
  top: 8.6667vw;
  font-size: 3.75vw;
  font-family: Glacial Indifference, Glacial Indifference-Bold;
  font-weight: 700;
  text-align: left;
  color: #514f4c;
}
.content-center{
  height: 48.75vw;
}
.content-left, .content-right{
  float: left;
}
.content-right input{
  width: 27.3333vw;
  height: 3.75vw;
  margin-top: 1.4583vw;
  margin-left: 5.9167vw;
  font-size: 2.9167vw;
  padding-left: 0.8333vw;
}
.question-one{
  font-size: 1.8333vw;
  font-family: Glacial Indifference, Glacial Indifference-Regular;
  font-weight: 400;
  text-align: left;
  color: #514f4c;
  margin-top: 15.3333vw;
  margin-left: 5.5833vw;

}
.question-two{
  margin-top: 1vw;
  margin-left: 5.5833vw;
  font-size: 1.25vw;
  font-family: Glacial Indifference, Glacial Indifference-Regular; /* Added for consistency */
  color: #514f4c; /* Added for consistency */
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 37vw;
  height: 35.75vw;
  overflow: hidden;
  border-radius: 1.6667vw;
  margin-top: 7.1667vw;
  margin-left: 8.3333vw;
  float: left;
}
.actionButton {
  display: block;
  width: 12vw;
  height: 3vw;
  background: #cfc5b3;
  border-radius: 1.5vw;
  cursor: pointer;
  margin-top: 2.75vw;
  margin-left: 5.6667vw;
  font-size: 1.8333vw;
  font-family: Glacial Indifference, Glacial Indifference-Bold;
  font-weight: 700;
  text-align: center;
  color: #514f4c;
  border: none; /* Good practice */
}
@media screen and (max-width: 768px) {
  .content-top{
    text-align: center;
    position: relative;
    width: 140%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 7.1615vw;
  }
  .content-center{
    height: 159.2448vw;
    overflow: hidden;
  }
  .content-left, .content-right{
    float: none;
    display: block;
  }
  .image-container{
    margin-top: 26.4323vw;
    margin-left: 15.2344vw;
    width: 68.3594vw;
    height: 66.0156vw;
  }
  .question-one{
    margin-top: 102.474vw; /* Adjusted since image takes space, but original used absolute positioning logic implicitly via margins */
    /* In QuoteInputor, question-one margin-top was huge (102vw) likely pushing it below image in mobile flow */
    margin-left: 10.2865vw;
    font-size: 4.8177vw;
    line-height: 6.3802vw;
    text-align: center;
    margin-left: 0;
  }
  .question-two{
    margin-top: 2.2135vw;
    font-size: 2.9948vw;
    text-align: center;
    margin-left: 0;
  }
  .content-right{ width: 100%; }
  /* input styles removed as no input */
  .actionButton {
    margin-top: 7.5521vw;
    margin-left: 10.2865vw; /* Kept from original but check centering */
    border-radius: 4.1016vw;
    width: 32.5521vw;
    height: 8.2031vw;
    font-size: 4.8177vw;
    margin: 7.5521vw auto 0; /* Centered */
  }
}
</style>

